import { Box } from '@mui/material';
import clsx from 'clsx';
import React, { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';

export interface FilterSelectorProps<T> {
  selected: T;
  options: T[];
  onChange: (option: T) => void;
}

export const FilterSelector = <T,>({
  selected,
  options,
  onChange,
}: FilterSelectorProps<T>): ReactElement => {
  const seed = useUIDSeed();

  return (
    <Box
      mt={12.5}
      display="flex"
      justifyContent="space-evenly"
      alignItems="center"
      fontSize="0.875em"
      fontWeight={600}
      color="#777"
      sx={{
        '& .option': {
          cursor: 'pointer',
          userSelect: 'none',
          WebkitTapHighlightColor: 'rgba(0,0,0,0)',
          outline: 'none',
          '&:focus-visible': {
            outline: theme => `2px auto ${theme.palette.primary.main}`,
            outlineOffset: 6,
          },
          '&.selected': {
            background: theme => theme.palette.primary.main,
            borderRadius: 4,
            color: '#fff',
          },
        },
      }}
      style={{
        gap: 10,
      }}
    >
      {options.map(option => (
        <Box
          key={seed(option)}
          className={clsx('option', selected === option && 'selected')}
          tabIndex={0}
          flex={1}
          py={7}
          px={13}
          whiteSpace="nowrap"
          onClick={() => onChange(option)}
          onKeyPress={(e: React.KeyboardEvent) => {
            if (e.key === ' ' || e.key === 'Enter') onChange(option);
          }}
        >
          {option}
        </Box>
      ))}
    </Box>
  );
};
